
import debounce from 'lodash.debounce';
import ClickOutside from 'vue-click-outside';
import { StyleColorSchemeType } from '../../styles/enums';
import { IconType } from '../icon/enums';
import Input from '../input';
import List from '../list';
import ListItem from '../list-item';
import SelectOptionsMixin from '../../mixins/select-options';
import { AutocompleteEventType, AutocompleteProperty } from './enums';
import Spinner from '../spinner';
import AutocompleteProps from './mixins/AutocompleteProps';

export const AUTOCOMPLETE_CHANGE_INPUT_DELAY = 300;

export default {
  name: 'Autocomplete',
  components: {
    Spinner,
    Input,
    List,
    ListItem,
  },
  directives: {
    ClickOutside,
  },
  mixins: [SelectOptionsMixin, AutocompleteProps],
  data() {
    return {
      isOpened: false,
      IconType,
      StyleColorSchemeType,
      AutocompleteProperty,
    };
  },
  computed: {
    menuStyles() {
      const autocompleteWrapperRef = this.$refs['autocomplete-wrapper'];

      if (!autocompleteWrapperRef) {
        return {};
      }

      const { offsetWidth, offsetHeight } = autocompleteWrapperRef;

      return {
        minWidth: `${offsetWidth}px`,
        top: `${offsetHeight}px`,
      };
    },
    appendIconType() {
      if (this[AutocompleteProperty.Value].length) {
        return IconType.CloseOutlined;
      }

      return null;
    },
  },
  methods: {
    // eslint-disable-next-line func-names
    handleInputChange: debounce(function (value) {
      if (!this.isOpened) {
        this.isOpened = true;
      }

      this.$emit(AutocompleteEventType.Change, value);
    }, AUTOCOMPLETE_CHANGE_INPUT_DELAY),
    handleOutsideClick() {
      this.isOpened = false;
    },
    handleInputClick() {
      if (this[AutocompleteProperty.Disabled]) {
        return;
      }

      this.isOpened = !this.isOpened;
    },
    handleOptionClick(value) {
      this.isOpened = false;
      this.$emit(AutocompleteEventType.Select, value);
    },
    handleResetIconClick() {
      this.$emit(AutocompleteEventType.Change, '');
    },
    getIsOptionSelected(value) {
      return this[AutocompleteProperty.Value] === value;
    },
  },
};
